import { COLOR, mq } from "@dmm-com/rocket-web-ui-library";

import styled from "@emotion/styled";

export const DivCampaignBanner = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  line-height: 1;
  color: ${COLOR.RED900.code};

  ${mq.sp} {
    margin-top: 8px;
  }
`;
